var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swmain"},[(!_vm.shouldHideHeader)?_c('Top',{on:{"indexInfo":_vm.indexInfo}}):_vm._e(),_c('div',{staticClass:"swas-type"},[_c('b-container',{staticClass:"m-0 p-0",attrs:{"fluid":"fluid"}},[_vm._t("default")],2)],1),_c('Footer',{staticClass:"footer-page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }